import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Loading from "../common/Loading";
import AppSnackbar from "../../common/AppSnackbar";
import { useTranslation } from "react-i18next";
import { startOfDay } from "date-fns";
import AppointmentCalendar from "./AppointmentCalendar";
import { useAppointmentAdminAPI } from "../../service/useAppointmentAdminAPI";

function AppointmentsManagement() {
  const { t } = useTranslation();
  const { getServices, getAppointmentsForDay } = useAppointmentAdminAPI();

  const [services, setServices] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [date, setDate] = useState(startOfDay(new Date()));

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  function handleFetchError(reasonKeyOrMessage) {
    setSnackbarMessage(
      typeof reasonKeyOrMessage === "string"
        ? reasonKeyOrMessage
        : t("reservationManagementFetchFailed"),
    );
    setOpenSnackbar(true);
  }

  useEffect(() => {
    let mounted = true;
    getServices()
      .then((list) => {
        if (mounted) setServices(list || []);
      })
      .catch(() => handleFetchError(t("reservationManagementFetchFailed")));
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let mounted = true;
    getAppointmentsForDay(date)
      .then((list) => {
        if (mounted) setAppointments(list || []);
      })
      .catch(() => handleFetchError(t("reservationManagementFetchFailed")));
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <>
      <Grid
        container
        justifyContent="center"
        sx={{ px: { xs: 1, sm: 2 }, py: { xs: 1, sm: 2 } }}
      >
        <Grid item xs={12} sm={12} sx={{ p: 2, m: 2 }} data-testid="appointments-management-container">
          <AppointmentCalendar
            services={services}
            appointments={appointments}
            date={date}
            setDate={setDate}
          />
          <AppSnackbar
            openSnackbar={openSnackbar}
            snackbarMessage={snackbarMessage}
            setOpenSnackbar={setOpenSnackbar}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default withAuthenticationRequired(AppointmentsManagement, {
  onRedirecting: () => <Loading />,
  returnTo: "/beheer/login",
});
